<template>
  <div id="footer">
    <div class="container">
      <div class="footer-border-bottom">
        <div class="row align-items-center mb-5 ">
          <div class="col-md-4 col-12 text-center">
            <router-link :to="{path: '/Home'}"><img alt="logo" height="60" src="../assets/img/logo.webp">
            </router-link>
            <div class="mt-5">
              <router-link :to="{ path: '/aboutUs'}">درباره ما</router-link>
            </div>
            <div class="mt-3">
              <router-link :to="{ path: '/contactUs'}">تماس با ما</router-link>
            </div>
            <div class="mt-4">
              <a href="https://t.me/+989197830724" target="_blank"><i class="fab fa-telegram footer-icon"></i></a>
              <a href="https://wa.me/+989123342362" target="_blank"><i
                  class="fab fa-whatsapp footer-icon mx-4"></i></a>
              <a href="https://www.instagram.com/shahkareghalam" target="_blank"><i
                  class="fab fa-instagram footer-icon"></i></a>
            </div>
          </div>
          <div class="col-md-4 col-12 text-center">
            <div class="footer-title">مشتریان</div>
            <!--            <div class="mt-3">
                          <router-link :to="{path: '/BlogPosts'}">وبلاگ</router-link>
                        </div>-->
            <div class="mt-3">
              <router-link :to="{path: '/OrderRecords'}">تاریخچه سفارشات</router-link>
            </div>
            <div class="mt-3">
              <router-link :to="{path: '/SuggestionCritic'}">شکایات</router-link>
            </div>
            <div class="mt-3">
              <router-link :to="{path: '/publicly'}">قوانین و مقررات</router-link>
            </div>
          </div>
          <div v-if="categories.length > 0" class="col-md-4 col-12 text-center">
            <div class="footer-title">دسته بندی ها</div>
            <div v-for="item in categories" :key="item.Item1" class="mt-5">
              <router-link :to="{path: '/categoryProducts', query:{categoryId:item.Item1}}">{{ item.Item2 }}
              </router-link>
            </div>
          </div>
        </div>
        <div class="text-center my-5">
          <a href='https://trustseal.enamad.ir/?id=573576&Code=uDTFtbIrf6KilZgzjN48lEeVIqciRa9x' referrerpolicy='origin'
             target='_blank'>
            <img alt=''
                 code='uDTFtbIrf6KilZgzjN48lEeVIqciRa9x'
                 referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=573576&Code=uDTFtbIrf6KilZgzjN48lEeVIqciRa9x' style='cursor:pointer'></a>
        </div>
      </div>
      <div class="text-center mt-3">
        <a href="https://izisys.com/" target="_blank"
           title="طراحی وب سایت، اپلیکیشن موبایل و سئو izisys.com"> طراحی وب سایت، اپلیکیشن موبایل و سئو
          <span class=""> izisys.com </span>
        </a>
      </div>
      <div class="text-center mt-2">تمامی حقوق وبسایت محفوظ و در اختیار انتشارات شاهکار قلم می باشد.</div>
    </div>
  </div>
</template>

<script>
let _this = null
export default {
  name: "Footer",
  data: () => ({
    categories: []
  }),
  mounted () {
    _this = this
    this.getData()
  },
  methods: {
    getImgUrl (pic) {
      return require('../assets/img/' + pic)
    },
    getData () {
      let urlencoded = new URLSearchParams();

      let requestOptions = {
        method: 'POST',
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Home/index", requestOptions)
          .then(response => response.text())
          .then(result => {

            let json = JSON.parse(result)
            _this.categories = json.NormalCategories


          })
          .catch(error => console.log('error', error));
    },

  }
}
</script>

<style scoped>

</style>